import React from 'react';
import { Checkbox } from '@material-ui/core';

const CellSelectRow = props => <Checkbox title="Pažymėti eilutę" {...props} />;

export default React.memo(CellSelectRow);
